import { useNavigate } from "react-router-dom";
import { FC, useContext, useState, useEffect } from 'react';
import { AppContext } from "../App";
import { INCOME_EXPENDITURE_FILE_TYPES } from "../types/types"

export const IncomeExpenditureOptions: FC = () => {
    const { accountNumberReq, setAccountNumberReq } = useContext(AppContext);

    const navigate = useNavigate();
    const [IncomeExpenditureDocType, setIncomeExpenditureDocType] = useState('');
    useEffect(() => {
        !accountNumberReq.uuid && navigate('/');
    });
    return (
        <div className="page">

            <div className="container">

                <h1 className="page__title u-m__b--l">Welcome</h1>
                <h2 className="u-m__b--l">Please note, selecting the right category will ensure your document reaches the correct place and is processed as efficiently as possible.</h2>

                <form onSubmit={e => { e.preventDefault(); navigate('/upload'); }}>

                    {INCOME_EXPENDITURE_FILE_TYPES.map(fileType => (
                        <div className="type-radio-option u-m__b--l" key={fileType.type}>
                            <input
                                className={`${fileType.css} u-m__r`}
                                type="radio"
                                name="fileType"
                                value={fileType.type}
                                required
                                checked={IncomeExpenditureDocType === fileType.type}
                                onChange={(e) => {
                                    setIncomeExpenditureDocType(fileType.type);
                                    setAccountNumberReq({ ...accountNumberReq, IncomeExpenditureDocType: fileType.type });
                                }
                                }
                            />
                            <label className="form__label">
                                <p className="type-radio__option-title">{fileType.heading}</p>
                                <p>{fileType.description}</p>
                            </label>
                        </div>
                    ))}

                    <input className="btn" type="submit" value="Continue" disabled={IncomeExpenditureDocType === ''} />
                </form>
            </div>
        </div >

    );
}
